import { tarifaGenericosService } from "@/_services";
export const tarifaGenerico = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    entity: {
      data: [],
      status: {},
    },
    delete: {
      data: [],
      status: {},
    },
    update: {
      data: [],
      status: {},
    },
    post: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getTarifasGenericosRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getTarifasGenericosSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getTarifasGenericosError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    deleteTarifaGenericoRequest(state) {
      state.delete.status = {
        deleting: true,
      };
    },
    deleteTarifaGenericoError(state, error) {
      state.delete.data = null;
      state.delete.status = {
        error,
      };
    },
    deleteTarifaGenericoSuccess(state, response) {
      state.delete.data = response;
      state.delete.status = {
        deleted: true,
      };
    },
    postTarifaGenericoRequest(state) {
      state.post.status = {
        creating: true,
      };
    },
    postTarifaGenericoError(state, error) {
      state.post.data = null;
      state.post.status = {
        error,
      };
    },
    postTarifaGenericoSuccess(state, response) {
      state.post.data = response;
      state.post.status = {
        created: true,
      };
    },
    updateTarifaGenericoRequest(state) {
      state.update.status = {
        updating: true,
      };
    },
    updateTarifaGenericoError(state, error) {
      state.update.data = null;
      state.update.status = {
        error,
      };
    },
    updateTarifaGenericoSuccess(state, response) {
      state.update.data = response;
      state.update.status = {
        updated: true,
      };
    },
    getTarifaGenericoByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getTarifaGenericoByIdError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    getTarifaGenericoByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getTarifasGenericos({ commit }, request) {
      commit("getTarifasGenericosRequest");
      tarifaGenericosService
        .getTarifasGenericos(request.pagination, request.query)
        .then((response) => {
          commit("getTarifasGenericosSuccess", response);
        })
        .catch((error) => {
          commit("getTarifasGenericosError", error);
        });
    },
    deleteTarifaGenerico({ commit }, id) {
      commit("deleteTarifaGenericoRequest");
      tarifaGenericosService
        .deleteTarifaGenerico(id)
        .then((res) => {
          commit("deleteTarifaGenericoSuccess", res);
        })
        .catch((error) => {
          commit("deleteTarifaGenericoError", error);
        });
    },
    postTarifaGenerico({ commit }, request) {
      commit("postTarifaGenericoRequest");
      tarifaGenericosService
        .postTarifaGenerico(request)
        .then((res) => {
          commit("postTarifaGenericoSuccess", res);
        })
        .catch((error) => {
          commit("postTarifaGenericoError", error);
        });
    },
    updateTarifaGenerico({ commit }, request) {
      commit("updateTarifaGenericoRequest");
      tarifaGenericosService
        .updateTarifaGenerico(request.id, request.body)
        .then((res) => {
          commit("updateTarifaGenericoSuccess", res);
        })
        .catch((error) => {
          commit("updateTarifaGenericoError", error);
        });
    },
    getTarifaGenericoById({ commit }, id) {
      commit("getTarifaGenericoByIdRequest");
      tarifaGenericosService
        .getTarifaGenericoById(id)
        .then((res) => {
          commit("getTarifaGenericoByIdSuccess", res);
        })
        .catch((error) => {
          commit("getTarifaGenericoByIdError", error);
        });
    },
  },
};
